import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createActivitySession,
  completeSession,
  saveProgress,
  skipActivity
} from '../api/activitySessions';

/**
 * Hook to manage activity session actions
 */
export const useActivitySession = () => {
  const queryClient = useQueryClient();

  const createSession = useMutation({
    mutationFn: createActivitySession,
    onSuccess: () => {
      // Invalidate dashboard to refetch with new session
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    }
  });

  const complete = useMutation({
    mutationFn: ({ sessionId, finalSnapshot }) =>
      completeSession(sessionId, finalSnapshot),
    onSuccess: () => {
      // Invalidate dashboard to show updated progress
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    }
  });

  const savePartialProgress = useMutation({
    mutationFn: ({ sessionId, snapshot }) => saveProgress(sessionId, snapshot)
  });

  const skip = useMutation({
    mutationFn: skipActivity,
    onSuccess: () => {
      // Invalidate dashboard to show next activity
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    }
  });

  return {
    createSession,
    complete,
    savePartialProgress,
    skip
  };
};
